<template>
    <div class="full-height">
          <crud-layout-search ref="crudLayoutSearch"
          :name="name" :interface="nmInterface"
          :id="id" :multiselect="true"
          :selection-force="true"
          :page-detail="detailPage"
          :pageTable="pageTable"
          @selection="onSelectRow"
          :row-buttons="true"
           />
    </div>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
import UnsyncedMessagePageTable from './UnsyncedMessagePageTable.vue'
import UnsyncedMessageDetail from './UnsyncedMessageDetail'

import { repository, messageBox } from 'jtech'
const { CrudLayoutSearch } = JtCrud

  @Component({
    name: 'UnsyncedMessage',
    components: { CrudLayoutSearch, UnsyncedMessagePageTable, UnsyncedMessageDetail },
    props: {
      name: String,
      id: String
    }
  })
class UnsyncedMessage extends Vue {
    nmInterface = 'unsyncedMessage.pesquisar'
    itemsTableSelected = []

    onSelectRow (_event) {
      this.itemsTableSelected = _event
    }

    mounted () {
      this.$refs.crudLayoutSearch.onButton('btExecutar', this.sendRequest)
    }

    get detailPage () {
      return UnsyncedMessageDetail
    }

    async sendRequest () {
      if (this.itemsTableSelected.length > 0) {
        await repository.resolveLogic('unsyncedMessage.resync', { grid: { ...this.itemsTableSelected } })
        this.$refs.crudLayoutSearch.refresh()
      } else {
        messageBox.warn(this.$gettext('NO_ROW_SELECTED'))
      }
    }

    get pageTable () {
      return UnsyncedMessagePageTable
    }
  }

export default UnsyncedMessage
</script>

  <style lang="stylus" scoped>

  </style>
